/* eslint-disable linebreak-style */
import React from 'react';
import Loadingimage from '../images/loading.PNG'

const Loadingscreen = () => {
  return (
    <div className="loading">
      <img className="loadingimage" src={Loadingimage} alt="site logo" />
    </div>)
}

export default Loadingscreen;